var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootprintIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ea580c"
  }, /*#__PURE__*/React.createElement("title", null, "Icons"), /*#__PURE__*/React.createElement("path", {
    d: "M33.21,76.08l.34,1a.56.56,0,0,1-.3.69l-1.16.53a.56.56,0,0,1-.79-.44l-.09-.71a.56.56,0,0,1,.19-.49l.92-.8A.56.56,0,0,1,33.21,76.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.88,71.94l.33,1a.56.56,0,0,1-.29.7l-1.17.53A.57.57,0,0,1,31,73.7L30.88,73a.53.53,0,0,1,.18-.49l.92-.8A.57.57,0,0,1,32.88,71.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.82,76.28l-.17,1a.54.54,0,0,0,.41.61l1.24.31a.55.55,0,0,0,.7-.56l0-.7a.54.54,0,0,0-.27-.44l-1-.61A.56.56,0,0,0,27.82,76.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.34,72.14l-.16,1a.54.54,0,0,0,.41.61l1.24.31a.56.56,0,0,0,.7-.56l0-.7a.54.54,0,0,0-.27-.44l-1-.61A.56.56,0,0,0,27.34,72.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.61,67.9l-.17,1a.55.55,0,0,0,.41.62l1.24.31a.56.56,0,0,0,.7-.56l0-.7a.56.56,0,0,0-.27-.45l-1-.61A.57.57,0,0,0,26.61,67.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.37,67.73l.34,1a.56.56,0,0,1-.3.69l-1.17.54a.56.56,0,0,1-.78-.44l-.09-.71a.51.51,0,0,1,.19-.49l.92-.8A.56.56,0,0,1,32.37,67.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.93,66.93l-.23,3.42a.56.56,0,0,0,.66.58l5.09-1a.57.57,0,0,0,.45-.64l-.47-2.79a.57.57,0,0,0-.6-.46l-4.39.35A.54.54,0,0,0,18.93,66.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.55,72.72l5.11-.92a.57.57,0,0,1,.66.49l.19,1.42a.59.59,0,0,1-.44.63l-5.21,1.17a.56.56,0,0,1-.69-.52l-.09-1.68A.56.56,0,0,1,19.55,72.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8,78.25l.85,2.2a.54.54,0,0,0,.81.24L26,77.43a.52.52,0,0,0,.17-.67l-.42-.88a.55.55,0,0,0-.68-.27l-5,1.94A.54.54,0,0,0,19.8,78.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,75.14V77.5a.53.53,0,0,1-.66.52l-5.45-1.38a.51.51,0,0,1-.4-.56l.08-1a.53.53,0,0,1,.53-.49h5.37A.53.53,0,0,1,41,75.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.91,70l-5.18.47a.57.57,0,0,0-.51.64l.2,1.42A.57.57,0,0,0,35,73l5.33-.24a.58.58,0,0,0,.53-.69l-.36-1.64A.56.56,0,0,0,39.91,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,64.11l1.06,3.26a.55.55,0,0,1-.5.72l-5.17.3a.56.56,0,0,1-.59-.51l-.23-2.81a.57.57,0,0,1,.46-.6l4.35-.74A.54.54,0,0,1,39,64.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51,47.17l-.19,1.95a.57.57,0,0,0,.2.49l2,1.68a.58.58,0,0,0,.94-.42l.09-2.06a.6.6,0,0,0-.2-.47l-1.95-1.56A.57.57,0,0,0,29.51,47.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.35,41.44l-.18,2a.54.54,0,0,1-.29.45l-3.79,2.28a.58.58,0,0,1-.85-.58l.29-2a.56.56,0,0,1,.29-.42l3.69-2.19A.57.57,0,0,1,28.35,41.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.68,41l-.19,2a.59.59,0,0,0,.2.5L33,46.39a.57.57,0,0,0,.94-.41l.1-2.07a.57.57,0,0,0-.21-.46l-3.22-2.83A.57.57,0,0,0,29.68,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.48,35.44l-.07,2a.57.57,0,0,1-.27.46l-4.46,2.92a.57.57,0,0,1-.88-.52L23,38.19a.59.59,0,0,1,.27-.43l4.36-2.82A.58.58,0,0,1,28.48,35.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.24,35.1l-.19,1.95a.58.58,0,0,0,.2.49L34.31,41a.56.56,0,0,0,.93-.41l.1-2.06a.56.56,0,0,0-.21-.47l-4-3.36A.57.57,0,0,0,30.24,35.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.36,29.69l-.25,2a.51.51,0,0,1-.28.41l-4.18,2.18a.53.53,0,0,1-.77-.55l.37-2.15a.52.52,0,0,1,.28-.38l4.06-2.09A.53.53,0,0,1,29.36,29.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.93,29.23l-.19,1.95a.57.57,0,0,0,.2.49l3.55,3a.56.56,0,0,0,.93-.41l.1-2.06a.59.59,0,0,0-.21-.47l-3.45-2.85A.57.57,0,0,0,30.93,29.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.15,
    y: 50.13,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(51.74 97.87) rotate(165.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.17,
    y: 50.01,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(42.18 115.62) rotate(-150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.84,
    y: 43.38,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(39.79 89.58) rotate(175.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.69,
    y: 43.9,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(61.65 102.08) rotate(-161.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.69,
    y: 37.22,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(36.2 78.73) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.14,
    y: 37.72,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(79.25 81.52) rotate(-177.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.33,
    y: 31.35,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(32.38 69.38) rotate(-171.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.14,
    y: 31.03,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(84.92 61.03) rotate(172.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.08,
    y: 25.2,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(27.9 60.71) rotate(-155.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.79,
    y: 24.74,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(83.22 44.82) rotate(167.72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.83,14c-5.45,0-9.31,6-10,7.5a.52.52,0,0,0,.23.8l4.4,2.63c.59.35.82.3,1.19-.31.89-1.48,1.62-2.75,4.46-2.85a5.6,5.6,0,0,1,4.51,2.3.53.53,0,0,0,.69.15L40.55,22a.52.52,0,0,0,.3-.82C39.65,18.75,35.18,14,29.83,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.71,25.64l3,2.74a.79.79,0,0,0,1.17-.17c.16-.27.33-.87,0-1.15L32.49,23.7a.83.83,0,0,0-1.16.17l-.54.59A.85.85,0,0,0,30.71,25.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.33,25.64l-3,2.74a.79.79,0,0,1-1.17-.17c-.17-.27-.34-.87,0-1.15l2.4-3.36a.85.85,0,0,1,1.17.17l.54.59A.85.85,0,0,1,29.33,25.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.71,47.17l.18,1.95a.54.54,0,0,1-.2.49l-2,1.68a.57.57,0,0,1-.93-.42l-.1-2.06a.58.58,0,0,1,.21-.47l2-1.56A.57.57,0,0,1,27.71,47.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,79.87l-5.38-1.66a.57.57,0,0,0-.46.05l-1.45.81a4.6,4.6,0,0,1-3.59.4L27.42,79A.64.64,0,0,0,27,79l-4.78,2.8a.59.59,0,0,0-.12.92h0a10.73,10.73,0,0,0,6.19,3.08l.58.08a10.89,10.89,0,0,0,4-.21l.8-.2a10.74,10.74,0,0,0,6.22-4.25s.26-.39.36-.51A.53.53,0,0,0,40,79.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.79,76.08l-.34,1a.56.56,0,0,0,.3.69l1.16.53a.56.56,0,0,0,.79-.44l.09-.71a.56.56,0,0,0-.19-.49l-.92-.8A.56.56,0,0,0,66.79,76.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.12,71.94l-.33,1a.56.56,0,0,0,.29.7l1.17.53A.57.57,0,0,0,69,73.7l.08-.71a.53.53,0,0,0-.18-.49L68,71.7A.57.57,0,0,0,67.12,71.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18,76.28l.17,1a.54.54,0,0,1-.41.61l-1.24.31a.55.55,0,0,1-.7-.56l0-.7a.54.54,0,0,1,.27-.44l1-.61A.56.56,0,0,1,72.18,76.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.66,72.14l.16,1a.54.54,0,0,1-.41.61l-1.24.31a.56.56,0,0,1-.7-.56l0-.7a.54.54,0,0,1,.27-.44l1-.61A.56.56,0,0,1,72.66,72.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.39,67.9l.17,1a.55.55,0,0,1-.41.62l-1.24.31a.56.56,0,0,1-.7-.56l0-.7a.56.56,0,0,1,.27-.45l1-.61A.57.57,0,0,1,73.39,67.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.63,67.73l-.34,1a.56.56,0,0,0,.3.69l1.17.54a.56.56,0,0,0,.78-.44l.09-.71a.51.51,0,0,0-.19-.49l-.92-.8A.56.56,0,0,0,67.63,67.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.07,66.93l.23,3.42a.56.56,0,0,1-.66.58l-5.09-1a.57.57,0,0,1-.45-.64l.47-2.79a.57.57,0,0,1,.6-.46l4.39.35A.54.54,0,0,1,81.07,66.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.45,72.72l-5.11-.92a.57.57,0,0,0-.66.49l-.19,1.42a.59.59,0,0,0,.44.63l5.21,1.17a.56.56,0,0,0,.69-.52l.09-1.68A.56.56,0,0,0,80.45,72.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2,78.25l-.85,2.2a.54.54,0,0,1-.81.24L74,77.43a.52.52,0,0,1-.17-.67l.42-.88a.55.55,0,0,1,.68-.27l5,1.94A.54.54,0,0,1,80.2,78.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,75.14V77.5a.53.53,0,0,0,.66.52l5.45-1.38a.51.51,0,0,0,.4-.56l-.08-1a.53.53,0,0,0-.53-.49H59.49A.53.53,0,0,0,59,75.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.09,70l5.18.47a.57.57,0,0,1,.51.64l-.2,1.42A.57.57,0,0,1,65,73l-5.33-.24a.58.58,0,0,1-.53-.69l.36-1.64A.56.56,0,0,1,60.09,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,64.11,60,67.37a.55.55,0,0,0,.5.72l5.17.3a.56.56,0,0,0,.59-.51l.23-2.81a.57.57,0,0,0-.46-.6l-4.35-.74A.54.54,0,0,0,61,64.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.49,47.17l.19,1.95a.57.57,0,0,1-.2.49l-2,1.68a.58.58,0,0,1-.94-.42l-.09-2.06a.6.6,0,0,1,.2-.47l2-1.56A.57.57,0,0,1,70.49,47.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.65,41.44l.18,2a.54.54,0,0,0,.29.45l3.79,2.28a.58.58,0,0,0,.85-.58l-.29-2a.56.56,0,0,0-.29-.42l-3.69-2.19A.57.57,0,0,0,71.65,41.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.32,41l.19,2a.59.59,0,0,1-.2.5L67,46.39a.57.57,0,0,1-.94-.41L66,43.91a.57.57,0,0,1,.21-.46l3.22-2.83A.57.57,0,0,1,70.32,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.52,35.44l.07,2a.57.57,0,0,0,.27.46l4.46,2.92a.57.57,0,0,0,.88-.52L77,38.19a.59.59,0,0,0-.27-.43L72.4,34.94A.58.58,0,0,0,71.52,35.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.76,35.1,70,37.05a.58.58,0,0,1-.2.49L65.69,41a.56.56,0,0,1-.93-.41l-.1-2.06a.56.56,0,0,1,.21-.47l4-3.36A.57.57,0,0,1,69.76,35.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.64,29.69l.25,2a.51.51,0,0,0,.28.41l4.18,2.18a.53.53,0,0,0,.77-.55l-.37-2.15a.52.52,0,0,0-.28-.38l-4.06-2.09A.53.53,0,0,0,70.64,29.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.07,29.23l.19,1.95a.57.57,0,0,1-.2.49l-3.55,3a.56.56,0,0,1-.93-.41l-.1-2.06a.59.59,0,0,1,.21-.47l3.45-2.85A.57.57,0,0,1,69.07,29.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.03,
    y: 50.13,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(15.9 -18.7) rotate(14.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.01,
    y: 50.01,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(-17.58 38.7) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.34,
    y: 43.38,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(3.55 -5.86) rotate(4.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.49,
    y: 43.9,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(-11.43 21.6) rotate(-18.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.49,
    y: 37.22,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.04,
    y: 37.72,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(-1.75 2.74) rotate(-2.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.84,
    y: 31.35,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(-4.03 12.26) rotate(-8.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.04,
    y: 31.03,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(4.6 -7.15) rotate(7.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.09,
    y: 25.2,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(-4.21 35.2) rotate(-24.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.39,
    y: 24.74,
    width: 6.82,
    height: 4.29,
    rx: 2.14,
    ry: 2.14,
    transform: "translate(7.11 -12.32) rotate(12.28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.17,14c5.45,0,9.31,6,10,7.5a.52.52,0,0,1-.23.8l-4.4,2.63c-.59.35-.82.3-1.19-.31-.89-1.48-1.62-2.75-4.46-2.85a5.6,5.6,0,0,0-4.51,2.3.53.53,0,0,1-.69.15L59.45,22a.52.52,0,0,1-.3-.82C60.35,18.75,64.82,14,70.17,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.29,25.64l-3,2.74a.79.79,0,0,1-1.17-.17c-.16-.27-.33-.87,0-1.15l2.41-3.36a.83.83,0,0,1,1.16.17l.54.59A.85.85,0,0,1,69.29,25.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.67,25.64l3,2.74a.79.79,0,0,0,1.17-.17c.17-.27.34-.87,0-1.15l-2.4-3.36a.85.85,0,0,0-1.17.17l-.54.59A.85.85,0,0,0,70.67,25.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.29,47.17l-.18,1.95a.54.54,0,0,0,.2.49l2,1.68a.57.57,0,0,0,.93-.42l.1-2.06a.58.58,0,0,0-.21-.47l-2-1.56A.57.57,0,0,0,72.29,47.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,79.87l5.38-1.66a.57.57,0,0,1,.46.05l1.45.81a4.6,4.6,0,0,0,3.59.4L72.58,79a.64.64,0,0,1,.47.06l4.78,2.8a.59.59,0,0,1,.12.92h0a10.73,10.73,0,0,1-6.19,3.08l-.58.08a10.89,10.89,0,0,1-4-.21l-.8-.2a10.74,10.74,0,0,1-6.22-4.25s-.26-.39-.36-.51A.53.53,0,0,1,60,79.87Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprintIcon);
export default __webpack_public_path__ + "static/media/footprintIcon.aa2b6747a6a6f9350d898636f9e4bb1b.svg";
export { ForwardRef as ReactComponent };